webpackJsonp([94818538752247],{

/***/ 34:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	__webpack_require__(14);
	
	__webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	}
	
	var ContactCouncilForm = function (_Component) {
	  _inherits(ContactCouncilForm, _Component);
	
	  function ContactCouncilForm(props) {
	    _classCallCheck(this, ContactCouncilForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var form = e.target;
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode(_extends({
	          'form-name': form.getAttribute('name')
	        }, _this.state))
	      }).then(function () {
	        return (0, _gatsbyLink.navigateTo)(form.getAttribute('action'));
	      }).catch(function (error) {
	        return alert(error);
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  ContactCouncilForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      'form',
	      {
	        name: 'signup',
	        className: 'form-inline',
	        method: 'post',
	        action: '/thanks/',
	        'data-netlify': 'true',
	        'data-netlify-honeypot': 'bot-field',
	        onSubmit: this.handleSubmit
	      },
	      _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'signup' }),
	      _react2.default.createElement(
	        'p',
	        { hidden: true },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Don\u2019t fill this out:',
	          ' ',
	          _react2.default.createElement('input', { name: 'bot-field', onChange: this.handleChange })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-group row p-3 p-md-4 container' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'col-12 mb-3', style: { textAlign: 'center' } },
	          'Stay up to date with our campaign'
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'sr-only', htmlFor: 'email' },
	          'Email'
	        ),
	        _react2.default.createElement('input', {
	          className: 'form-control form-control-lg col-12 mb-2',
	          name: 'email',
	          type: 'text',
	          placeholder: 'Email',
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(
	          'label',
	          { className: 'sr-only', htmlFor: 'zipcode' },
	          'Zipcode'
	        ),
	        _react2.default.createElement('input', {
	          className: 'form-control form-control-lg col-12 mb-2',
	          name: 'zipcode',
	          type: 'text',
	          placeholder: 'Zipcode',
	          onChange: this.handleChange
	        }),
	        _react2.default.createElement(
	          'label',
	          { className: 'sr-only', htmlFor: 'publicSupport' },
	          'Would you like to be listed as a public supporter?'
	        ),
	        _react2.default.createElement(
	          'select',
	          {
	            className: 'custom-select mb-2 col-12 form-control form-control-lg',
	            name: 'publicSupport',
	            onChange: this.handleChange,
	            defaultValue: 0
	          },
	          _react2.default.createElement(
	            'option',
	            { value: 0 },
	            'Show me as a public supporter?'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'yes' },
	            'Yes'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'no' },
	            'No'
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'col-12 mb-2 btn btn-success btn-lg', type: 'submit' },
	          'Submit'
	        )
	      )
	    );
	  };
	
	  return ContactCouncilForm;
	}(_react.Component);
	
	exports.default = ContactCouncilForm;
	module.exports = exports['default'];

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/VoteYay_Long_4C.1926b6e8.png";

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Overton_Impulse_FINAL.ef8c3229.mp4";

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Overton_Impulse_FINAL.87960a0b.webm";

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EndorsementForm = __webpack_require__(38);
	
	var _EndorsementForm2 = _interopRequireDefault(_EndorsementForm);
	
	var _StoryForm = __webpack_require__(26);
	
	var _StoryForm2 = _interopRequireDefault(_StoryForm);
	
	var _gatsbyImage = __webpack_require__(8);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Overton_Impulse_FINAL = __webpack_require__(368);
	
	var _Overton_Impulse_FINAL2 = _interopRequireDefault(_Overton_Impulse_FINAL);
	
	var _Overton_Impulse_FINAL3 = __webpack_require__(369);
	
	var _Overton_Impulse_FINAL4 = _interopRequireDefault(_Overton_Impulse_FINAL3);
	
	var _VoteYay_Long_4C = __webpack_require__(36);
	
	var _VoteYay_Long_4C2 = _interopRequireDefault(_VoteYay_Long_4C);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var richardOverton = {
	  header: 'Richard Overton\'s Story',
	  headline: 'What\u2019s a better place to be safe than your house?',
	  story: [{
	    text: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Richard Overton is America\u2019s oldest living WWII Veteran. Since 1948, he has owned his own home in the heart of East Austin.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Over the years, time took its toll on the home. The original wiring from 1948 was becoming faulty and things like the water heater were beginning to stop working. Mr. Overton was also in danger of tripping on his carpet, falling in his shower and overheating in the summers with no central air.'
	      )
	    ),
	    media: _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement('iframe', {
	        className: 'responsive-iframe',
	        frameborder: '0',
	        marginheight: '0',
	        marginwidth: '0',
	        src: 'https://cbsaustin.com/embed/news/local/nations-oldest-living-ww-ii-veteran-enjoying-newly-renovated-austin-home?external-id=b4d246c1cad04f4aab1a90db3649e3f6'
	      })
	    )
	  }, {
	    text: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'This is when Meals on Wheels Central Texas stepped in.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Through a partnership with the City, they replaced the original wiring in his home, installed central air and heating, widened doors to allow accessibility and remodeled his kitchen. They also removed the carpet so it was no longer a trip hazard and made his bathroom handicapped accessible.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Now, Mr. Overton can stay in the home he has owned for 70 years and live a healthier, more stable life.'
	      )
	    ),
	    media: _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'video',
	        { controls: true, style: { width: '100%', border: '3px solid black' } },
	        _react2.default.createElement('source', { src: _Overton_Impulse_FINAL2.default, type: 'video/mp4' }),
	        _react2.default.createElement('source', { src: _Overton_Impulse_FINAL4.default, type: 'video/webm' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Your browser doesn\'t support HTML5 video. Here is a',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: _Overton_Impulse_FINAL2.default },
	            'link to the video'
	          ),
	          ' instead.'
	        )
	      )
	    )
	  }, {
	    text: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Right now, 25% of seniors in Central Texas live under 200% of the poverty level. These are our neighbors who have lived in their homes for sometimes 3 to 4 generations, but have never been able to afford critical repairs needed for safe, healthy environments.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Through the Affordable Housing Bond, we can help our seniors on fixed-incomes stay in their homes. We can keep disabled seniors like Mr. Overton safe.'
	      )
	    ),
	    media: ''
	  }],
	  callToAction: _react2.default.createElement(
	    'div',
	    { style: { textAlign: 'center' } },
	    _react2.default.createElement('img', {
	      src: _VoteYay_Long_4C2.default,
	      alt: 'Vote Yay for Prop A',
	      style: { maxWidth: '100%', marginBottom: '20px' }
	    }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Vote Yay for Prop A on November 6th.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Do it for your neighbors. Do it for Veterans like Mr. Overton.'
	    )
	  )
	};
	
	var RichardOvertonsStory = function RichardOvertonsStory(props) {
	  return _react2.default.createElement(StoryTemplate, {
	    header: richardOverton.header,
	    headline: richardOverton.headline,
	    story: richardOverton.story,
	    callToAction: richardOverton.callToAction,
	    primaryImage: props.data.richardOverton.sizes,
	    secondaryImage: props.data.richardOverton2.sizes,
	    thirdImage: props.data.seniors.sizes
	  });
	};
	
	var StoryHeader = function StoryHeader(_ref) {
	  var header = _ref.header,
	      headline = _ref.headline,
	      secondaryImage = _ref.secondaryImage;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      { className: 'mb-4' },
	      header
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row align-items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm', style: { textAlign: 'center' } },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          title: 'Richard Overton, World War II Veteran',
	          alt: 'Richard Overton, World War II Veteran',
	          sizes: secondaryImage,
	          style: {
	            width: '100%',
	            maxHeight: '90vh',
	            border: '3px solid black'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'col' },
	        headline
	      )
	    )
	  );
	};
	
	var StoryTemplate = function StoryTemplate(_ref2) {
	  var header = _ref2.header,
	      headline = _ref2.headline,
	      body1 = _ref2.body1,
	      body2 = _ref2.body2,
	      story = _ref2.story,
	      callToAction = _ref2.callToAction,
	      primaryImage = _ref2.primaryImage,
	      secondaryImage = _ref2.secondaryImage,
	      thirdImage = _ref2.thirdImage;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'StoryTemplate container py-4' },
	    _react2.default.createElement(StoryHeader, {
	      header: header,
	      headline: headline,
	      primaryImage: primaryImage,
	      secondaryImage: secondaryImage
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'row py-4' },
	      _react2.default.createElement('div', {
	        className: 'col',
	        style: { borderRight: '4px dashed black', height: '100px' }
	      }),
	      _react2.default.createElement('div', { className: 'col' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row align-items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm' },
	        story[0].text
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm' },
	        story[0].media
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row py-4' },
	      _react2.default.createElement('div', {
	        className: 'col',
	        style: { borderRight: '3px dashed black', height: '100px' }
	      }),
	      _react2.default.createElement('div', { className: 'col' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row align-items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm', style: { textAlign: 'center' } },
	        story[1].media
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm' },
	        story[1].text
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row py-4' },
	      _react2.default.createElement('div', {
	        className: 'col',
	        style: { borderRight: '3px dashed black', height: '100px' }
	      }),
	      _react2.default.createElement('div', { className: 'col' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row align-items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm' },
	        story[2].text
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm', style: { textAlign: 'center' } },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          title: 'women laughing',
	          alt: 'women laughing',
	          sizes: thirdImage,
	          style: {
	            width: '100%',
	            maxHeight: '90vh',
	            border: '3px solid black'
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row py-4' },
	      _react2.default.createElement('div', {
	        className: 'col',
	        style: { borderRight: '3px dashed black', height: '100px' }
	      }),
	      _react2.default.createElement('div', { className: 'col' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      callToAction,
	      _react2.default.createElement(_StoryForm2.default, null)
	    )
	  );
	};
	
	exports.default = RichardOvertonsStory;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-stories-richard-overton-js-6be961e16ca524cbb532.js